/* 🤖 this file was generated by svg-to-ts */
export const waytrArrowLeft = {
    name: 'arrow_left',
    data: `<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.1 48.1"><path d="M37.5,2.95c0-.74-.29-1.49-.85-2.06-1.13-1.13-2.99-1.13-4.12,0L11.45,21.98c-.54,.54-.85,1.31-.85,2.06s.27,1.48,.85,2.06l21.06,21.06c1.11,1.18,3.02,1.19,4.14,.07s1.13-2.99,0-4.12h0S17.59,24.07,17.59,24.07L36.65,5.01c.56-.56,.85-1.32,.85-2.06h0Z"/></svg>`,
};
